// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {586: "recorder",621: "profiler",}[chunkId] + "-internal-f53bd8b5-24bc-4f2b-bb70-e9e88e9db317-" + {586: "b827fcac99f8e44b",621: "e009dd1e6f9e70c3",}[chunkId] + ".js"
}